import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import elTranslations from '../locales/el.json';

const resources = {
  el: { translation: elTranslations },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'el',
    fallbackLng: 'el',
    interpolation: {
      escapeValue: false,
    },
  });

document.documentElement.lang = 'el';
localStorage.setItem('ikonomakis-language', 'el');

export default i18n;